<template>
  <v-container fluid pa-0>
    <NewGridProjetos 
      title="Projetos"
      :headers="projetoHeaders"
      :items="projetos"
      itemKey="IdProjeto"
      :loading="projetoLoading"
      @aplicaFiltros="aplicaFiltros"
      @atualizaPreferencias="atualizaPreferenciasUsuario"
      @changeLayoutSql="changeLayoutSql"
      @deleteItem="deleteItem"
      @deleteItemSelected="deleteItemSelected"
      @finalizaItem="finalizaItem"
      @finalizaItemSelected="finalizaItemSelected"
      @abreModalDuplicaProjeto="abreModalDuplicaProjeto"
    />
      <!-- @abreModalEditPrevisao="abreModalEditPrevisao"
      @abreModalEditSituacao="abreModalEditSituacao"
      @abreModalEditResponsavel="abreModalEditResponsavel"
      @abreModalEditColaborador="abreModalEditColaborador"
      @abreModalEditCliente="abreModalEditCliente"
      @abreModalEditTipoAtividade="abreModalEditTipoAtividade"
      @abreModalEditTag="abreModalEditTag" -->

    <!-- Modal Duplicar Atividade -->
    <ModalDuplicaProjeto 
      v-model="dialogDuplicaProjeto"
      :projeto="projeto"
      :loading="duplicaProjetoLoading"
      @duplicaProjeto="duplicaProjetoItem"
    />
    <!-- Modal Setar Previsão -->
    <!-- <ModalEditPrevisao 
      v-model="dialogPrevisao"
      :atividade="atividade"
      :loading="setaPrevisaoLoading"
      @setaPrevisao="setaPrevisaoItem"
      @setaPrevisaoSelected="setaPrevisaoItemSelected"
    /> -->
    <!-- Modal Setar Situação -->
    <!-- <ModalEditSituacao 
      v-model="dialogSituacao"
      :atividade="atividade"
      :loading="setaSituacaoLoading"
      @setaSituacao="setaSituacaoItem"
      @setaSituacaoSelected="setaSituacaoItemSelected"
    /> -->
    <!-- Modal Setar Responsável -->
    <!-- <ModalEditResponsavel 
      v-model="dialogResponsavel"
      :atividade="atividade"
      :loading="setaResponsavelLoading"
      @setaResponsavel="setaResponsavelItem"
      @setaResponsavelSelected="setaResponsavelItemSelected"
    /> -->
    <!-- Modal Setar Colaborador -->
    <!-- <ModalEditColaborador 
      v-model="dialogColaborador"
      :atividadeColaborador="atividadeColaborador"
      :loading="setaColaboradorLoading"
      @setaColaborador="setaColaboradorItem"
      @setaColaboradorSelected="setaColaboradorItemSelected"
    /> -->
    <!-- Modal Setar Tag -->
    <!-- <ModalEditTag 
      v-model="dialogTag"
      :atividadeTag="atividadeTag"
      :loading="setaTagLoading"
      @setaTag="setaTagItem"
      @setaTagSelected="setaTagItemSelected"
    /> -->
    <!-- Modal Setar Cliente -->
    <!-- <ModalEditCliente 
      v-model="dialogCliente"
      :atividadeCliente="atividadeCliente"
      :loading="setaClienteLoading"
      @setaCliente="setaClienteItem"
      @setaClienteSelected="setaClienteItemSelected"
    /> -->
    <!-- Modal Setar Tipo Atividade -->
    <!-- <ModalEditTipoAtividade 
      v-model="dialogTipoAtividade"
      :atividade="atividade"
      :loading="setaTipoAtividadeLoading"
      @setaTipoAtividade="setaTipoAtividadeItem"
      @setaTipoAtividadeSelected="setaTipoAtividadeItemSelected"
    /> -->
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import NewGridProjetos from '../components/projeto/NewGridProjetos';
import Projeto from '@/domain/projeto/Projeto';
import ProjetoColaborador from '@/domain/projeto/ProjetoColaborador';
import ModalDuplicaProjeto from '@/components/projeto/ModalDuplicaProjeto';
import { changePageTitle } from '../utils/changePageTitle';
// import ProjetoTag from '@/domain/projeto/ProjetoTag';
// import ModalEditPrevisao from '@/components/atividade/ModalEditPrevisao';
// import ModalEditSituacao from '@/components/atividade/ModalEditSituacao';
// import ModalEditResponsavel from '@/components/atividade/ModalEditResponsavel';
// import ModalEditColaborador from '@/components/atividade/ModalEditColaborador';
// import ModalEditCliente from '@/components/atividade/ModalEditCliente';
// import ModalEditTag from '@/components/atividade/ModalEditTag';
// import ModalEditTipoAtividade from '@/components/atividade/ModalEditTipoAtividade';

export default {
  name: 'NewProjetosView',
  components: {
    NewGridProjetos,
    ModalDuplicaProjeto,
    // ModalEditPrevisao,
    // ModalEditSituacao,
    // ModalEditResponsavel,
    // ModalEditColaborador,
    // ModalEditCliente,
    // ModalEditTag,
    // ModalEditTipoAtividade,
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['A'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100003
      },
      projetoHeaders: [
        { text: "ID", value: "IdProjeto" },
        { text: "Descrição", value: "Projeto" },
        { text: "Duração Limite", value: "DuracaoLimite" },
        { text: "Cliente", value: "Fantasia" },
        { text: "Previsão", value: "DataPrevisao" },
        { text: "Tipo", value: "TipoProjeto" },
        { text: "Responsável", value: "Responsavel" },
        { text: "Situação", value: "Situacao" },
        { text: "Status", value: "Status" },
        { text: "GUT", value: "ValorGut" },
        { text: "NPS", value: "ValorNps" }
      ],
      projetoLoading: false,
      // Modal
      cliente: null,
      projeto: null,
      projetoColaborador: new ProjetoColaborador(),
      dialogDuplicaProjeto: false,
      duplicaProjetoLoading: false,
      // projetoTag: new ProjetoTag(),
      // dialogPrevisao: false,
      // dialogSituacao: false,
      // dialogResponsavel: false,
      // dialogColaborador: false,
      // dialogCliente: false,
      // dialogTag: false,
      // dialogTipoAtividade: false,
      // setaPrevisaoLoading: false,
      // setaSituacaoLoading: false,
      // setaResponsavelLoading: false,
      // setaColaboradorLoading: false,
      // setaClienteLoading: false,
      // setaTagLoading: false,
      // setaTipoAtividadeLoading: false,
    }
  },
  computed: {
    ...mapGetters(["projetos", "projetosSelected", "user"])
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      "fetchMeusProjetosSql",
      "fetchSituacoesProjeto",
      "fetchPeriodoProjetosSql",
      "fetchLayoutsSqlUsuario",
      "updateProjeto",
      "deleteProjeto",
      "finalizarProjetoNode",
      "resetProjetosSelected",
      "addProjetoColaborador",
      "duplicaProjeto",
      "updateLayoutSqlUsuario"
    ]),
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    atualizaPreferenciasUsuario(preferencias) {
      if (preferencias.atualiza) {
        delete preferencias.atualiza;
        this.updateLayoutSqlUsuario({
          IdLayoutSql: this.args.idLayoutSql,
          IdUsuario: this.user.IdUsuario,
          Preferencias: preferencias
        });
      }
    },
    async aplicaFiltros(payload) {
      this.projetoLoading = true;
      if (payload && payload.filtro === 'periodo') {
        this.args.dataInicial = this.moment(payload.dataInicial).format('YYYY-MM-DD');
        this.args.dataFinal = this.moment(payload.dataFinal).format('YYYY-MM-DD');
        await this.atualizaPreferenciasUsuario(payload);
        await this.fetchPeriodoProjetosSql(this.args);
      } else {
        this.args.dataInicial = null;
        this.args.dataFinal = null;
        await this.atualizaPreferenciasUsuario(payload);
        await this.fetchMeusProjetosSql(this.args);
      }
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100003 });
      this.projetoLoading = false;
    },
    finalizaItemSelected() {
      if (this.projetosSelected.length) {
        if (confirm(`Tem certeza que deseja finalizar: ${this.projetosSelected.length} registros?`)) {
          let promises = [];

          this.projetosSelected.forEach(item => {
            item.Status = 'F';
            promises.push(this.finalizarProjetoNode(item));
          });
          Promise.all(promises)
            .then(() => {
              this.resetProjetosSelected();
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao finalizar as atividades: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um projeto para finalizar.', status: 'error' });
      }
    },
    deleteItemSelected() {
      if (this.projetosSelected.length) {
        if (confirm(`Tem certeza que deseja excluir: ${this.projetosSelected.length} registros?`)) {
          let promises = [];

          this.projetosSelected.forEach(item => {
            promises.push(this.deleteProjeto(item.IdProjeto));
          });
          Promise.all(promises)
            .then(() => {
              this.resetProjetosSelected();
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os projetos: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um projeto para excluir.', status: 'error' });
      }
    },
    // Ações para visão coluna
    deleteItem(item) {
      if (confirm(`Tem certeza que deseja excluir: ${item.Projeto}?`)) {
        this.deleteProjeto(item.IdProjeto)
          .then(() => this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' }))
          .catch(error => this.showNotification({ text: `Ocorreu um erro ao excluir o projeto: ${error}`, status: 'error' }));
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    finalizaItem(item) {
      if (confirm(`Tem certeza que deseja finalizar: ${item.Projeto}?`)) {
        item.Status = 'F';
        this.finalizarProjetoNode(item)
          .then(() => this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' }))
          .catch(error => this.showNotification({ text: `Ocorreu um erro ao finalizar o projeto: ${error}`, status: 'error' }));
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    // Modals
    abreModalDuplicaProjeto(projeto) {
      if (projeto !== null) {
        this.projeto = Object.assign({}, projeto);
        this.dialogDuplicaProjeto = true;
      } else if (this.projetosSelected.length) {
        this.projeto = null;
        this.dialogDuplicaProjeto = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos um projeto para duplicar.', status: 'error' });
      }
    },
    duplicaProjetoItem(obj) {
      if (obj.projetos.length) {
        this.duplicaProjetoLoading = true;
        this.duplicaProjeto(obj)
          .then(() => {
            this.dialogDuplicaProjeto = false;
            this.projeto = new Projeto();
            this.resetProjetosSelected();
            this.duplicaProjetoLoading = false;
            this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
          })
          .catch(error => {
            this.showNotification({ text: `Ocorreu um erro ao duplicar o(s) projeto(s) ${error}`, status: 'error' })
            this.duplicaProjetoLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos um projeto para duplicar.`, status: 'error' });
      }
    },
  },
  async created() {
    changePageTitle('Projetos');
    await this.fetchSituacoesProjeto();
  }
}
</script>

<style>

</style>